/**
 * GameHUD Component
 * Reusable heads-up display for score, moves, timer
 * Canonical version extracted from Board.js
 */

import React from 'react';
import PropTypes from 'prop-types';

function GameHUD({
  score,
  moves,
  timeRemaining,
  levelClass,
  showTimer = true,
  showMoves = true,
  additionalInfo = null
}) {
  return (
    <div className={`gameInfo ${levelClass}`}>
      {additionalInfo}

      <div className={`scoreContainer ${levelClass}`}>
        score: {score}
      </div>

      {showMoves && (
        <div className={`scoreContainer ${levelClass}`}>
          moves: {moves}
        </div>
      )}

      {showTimer && timeRemaining !== null && (
        <div className={`timerContainer ${levelClass}`}>
          {Math.max(0, timeRemaining).toFixed(1)}s
        </div>
      )}
    </div>
  );
}

GameHUD.propTypes = {
  score: PropTypes.number.isRequired,
  moves: PropTypes.number.isRequired,
  timeRemaining: PropTypes.number,
  levelClass: PropTypes.string.isRequired,
  showTimer: PropTypes.bool,
  showMoves: PropTypes.bool,
  additionalInfo: PropTypes.node
};

GameHUD.defaultProps = {
  timeRemaining: null,
  showTimer: true,
  showMoves: true,
  additionalInfo: null
};

export default GameHUD;
